<template>
  <div id="income_popup" class="open" v-show="page && page== 'others' && receiveRecordTeam && receiveRecordTeam!= '' ">
    <div class="income_popup_inner">
      <!-- <p v-show="btnColorRed" class="income_popup_txt">録音中1...</p> -->
      <p v-show="!btnColorRed" class="income_popup_txt" @click="closeIcon">閉じる</p>
      <!-- <p v-show="!btnColorRed" class="income_popup_txt" style="margin-top:5px;">マイクボタンを押しながら録音</p> -->
      <div >
        <img alt="録音" class="income_btn"
          :src="[this.btnColorRed ? require('../assets/img/home/btn_income_red.png') : require('../assets/img/home/btn_income02.png')]"
          @touchstart="mousedown" @touchend="mouseup"
          @mousedown="mousedown" @mouseup="mouseup"
          onselectstart="return false" ondragstart="return false"
      ></div>
    </div>
  </div>
  <div v-show="page && page !== 'others'">
    <!-- <span :class="[this.btnColorRed ? 'text-voice' : 'display-class']">録音中2...</span> -->
    <img class="btn-voice"  alt=""
         :src="[this.btnColorRed ? require('../assets/img/home/btn_income_red.png') : require('../assets/img/home/btn_income.png')]"
         @touchstart="mousedown" @touchend="mouseup"
         @mousedown="mousedown" @mouseup="mouseup"
         onselectstart="return false" ondragstart="return false"/>
  </div>


</template>

<script>
import {uploadAudio} from "@/services/video";
import {Toast} from "vant";

export default {
  name: "Audio",
  props: {
  },
  data() {
    return {
      btnColorRed: false,
      team_id: "",
      recorder: null,
      recordStream: null,
      streamFile: [],
      recordTimeout: null,
      receiveRecordTeam: "",
      page: "",
      // 机选按下松开间隔用
      startTime: 0,
      endTime: 0,
    };
  },
  mounted() {
  },
  methods: {
    closeIcon(){
      this.receiveRecordTeam = "";
    },
    async mousedown() {
      if(this.receiveRecordTeam == ""){
        Toast.fail("チームを選択してください");
        return;
      }
      this.startTime = new Date().getTime();
      this.recordTimeout = setTimeout(() => {
        this.btnColorRed = true;
      }, 500);
      if (this.recordStream) {
        this.recordStream.getTracks().forEach((track) => {
          track.stop()
        })
      }
      this.recordStream = await navigator.mediaDevices.getUserMedia({audio: true, video: false,});
      this.recorder = new MediaRecorder(this.recordStream);
      this.recorder.ondataavailable =  (event)=> {
        if (event.data.size === 0) return;
        this.streamFile.push(event.data);
      };
      this.recorder.start();
    },
    async mouseup(){
      if(this.receiveRecordTeam == ""){
        return;
      }
      if (this.recordTimeout) {
        clearTimeout(this.recordTimeout);
      }
      this.btnColorRed = false;
      if (this.recorder && this.recorder.state === 'recording') {
        this.recorder.onstop = async () => {
          this.endTime = new Date().getTime();
          if (this.endTime - this.startTime < 1000) {
            Toast("録音の時間が短すぎます");
          }else{
            let params = {};
            let audioBlob = new Blob(this.streamFile, {'type': 'audio/wav'});
            params['team_ids'] = this.receiveRecordTeam;
            let formData = new FormData();
            formData.append('audio', audioBlob, 'audio');
            formData.append('msg',JSON.stringify(params))
            await uploadAudio(formData);
          }
          // 清空streamFile以便于下次使用
          this.streamFile = [];
          if (this.recordStream) {
            this.recordStream.getAudioTracks().forEach((track) => {
              track.stop()
            });
          }
          //在事件处理结束后，重置recorder为null，以供下次使用
          this.recordStream = null;
          this.recorder = null;
          if(this.$route.path !='/audioBridgeList' && this.$route.path !='/audioBridge'){
            this.receiveRecordTeam ="";
            this.page ="others";
          }
        };
        this.recorder.stop();
      } else {
        if (this.recordStream) {
          this.recordStream.getAudioTracks().forEach((track) => {
            track.stop()
          })
        }
        this.recordStream = null;
        this.recorder = null;
      }
    },
  },
};
</script>

<style scoped>
.btn-voice{
  position: fixed;
  width: 300px;
  bottom: 40px;
  left:50%;
  transform: translate(-50%);
  border-radius:50%;
  padding: 10px;
  z-index: 2;
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
.text-voice{
  position: fixed;
  bottom: 95px;
  left:50%;
  transform: translate(-50%);
  border-radius:50%;
  padding: 10px;
  z-index: 3;
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
.display-class{
  display: none;
}
</style>
